import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import S from 'constants/string.const';
import { useTheme } from 'providers/Theme.provider';

import CN from './FormsEmptyState.module.scss';

export const FormsEmptyState = ({ openTemplateModal }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  return (
    <div data-bem="FormsEmptyState" className={cn({ [CN.component]: true, [CN.darkMode]: isDarkMode })}>
      <div className={CN.illustration}>
        <span className={CN.illustrationEmoji}>{S.clipboardDocument}</span>
      </div>
      <h3 className={CN.title}>{t('consultationForms.emptyState.title')}</h3>
      <p className={CN.subtitle}>{t('consultationForms.emptyState.subtitle')}</p>

      <Button variant="primaryForce" onClick={openTemplateModal} tag="FormsEmptyState__newForm">
        {t('consultationForms.emptyState.emptyStateButton')}
      </Button>
    </div>
  );
};
